import { FormControl, Select } from '@mui/material';
import styled from 'styled-components';

import { ClearButton } from '@/shared/components/ui/button/clear-button/clear-button';
import { TStyledTextFieldProps } from '@/shared/components/ui/form/components/text-field/text-field.types';
import { TPositionedClearButtonProps } from '@/shared/components/ui/styled-select/styled-select.types';

export const CustomFormControl = styled(FormControl)`
  && {
    position: relative;
  }
`;

export const CustomSelect = styled(Select)<TStyledTextFieldProps>`
  && {
    color: ${({ theme }) => theme.palette.text.primary};
    height: ${({ theme, $size }) => theme.shape.inputHeight[$size || 'medium']};
    border-radius: ${({ theme, $size }) =>
      theme.shape.inputRadius[$size || 'medium']};
    transition: all 0.2s ease-in-out;
    background: ${({ theme }) => theme.palette.background.input};

    .MuiSelect-select {
      ${({ theme }) => theme.typography.p8};
      min-height: unset;
      // MUI's block padding outgrew the root's fixed height; line-height, not flex, keeps the ellipsis.
      box-sizing: border-box;
      height: 100%;
      padding-block: 0;
      line-height: ${({ theme, $size }) =>
        theme.shape.inputHeight[$size || 'medium']};

      // line-height only centres inline values; a block renderValue (e.g. icon + label Stack) must fill the height.
      & > div {
        height: 100%;
      }
    }

    input {
      padding: 0.625rem 0.75rem;

      &::placeholder {
        opacity: 1;
        color: ${({ theme }) => theme.palette.text.secondary};
      }
    }

    svg {
      color: ${({ theme }) => theme.palette.primary.main};
    }

    fieldset {
      border: none;
      box-shadow: inset 0 0 0 1px ${({ theme }) => theme.palette.stroke.primary};
    }

    &:hover {
      fieldset {
        box-shadow: inset 0 0 0 1px
          ${({ theme }) => theme.palette.stroke.secondary};
      }
    }

    &.Mui-focused {
      fieldset {
        box-shadow: inset 0 0 0 1px ${({ theme }) => theme.palette.primary.main};
      }
    }

    &.Mui-error {
      background: ${({ theme }) => theme.palette.danger.light};

      fieldset {
        box-shadow: inset 0 0 0 1px
          ${({ theme }) => theme.palette.status.red.stroke};
      }
    }

    &.Mui-disabled {
      background: ${({ theme }) => theme.palette.background.default};

      svg {
        color: ${({ theme }) => theme.palette.text.disabled};
      }

      fieldset {
        box-shadow: inset 0 0 0 1px
          ${({ theme }) => theme.palette.stroke.primary};
      }
    }
  }
`;

export const PositionedClearButton = styled(
  ClearButton,
)<TPositionedClearButtonProps>`
  && {
    position: absolute;
    right: 2.25rem;
    top: ${({ $hasLabel }) => ($hasLabel ? '2rem' : '0.125rem')};
  }
`;
